export default __webpack_public_path__ + "static/media/63.62f0449d.png";